module.exports = __webpack_public_path__ + "img/2696.4da9ab8.svg";